import * as D from '../../def';
export const annotation:D.IAnnotation = {
  circle: {
    pricePoints: [
      // {
      //   color: 'red',
      //   date: {
      //     year: 2010,
      //     month: 11,
      //     day: 8,
      //   },
      // },
      {
        color: 'red',
        date: {
          year: 2011,
          month: 6,
          day: 9,
        },
      },
      {
        color: 'red',
        date: {
          year: 2013,
          month: 4,
          day: 9,
        },
      },
      {
        color: 'red',
        date: {
          year: 2013,
          month: 11,
          day: 30,
        },
      },
      {
        color: 'green',
        date: {
          year: 2015,
          month: 1,
          day: 15,
        },
      },
      {
        color: 'red',
        date: {
          year: 2017,
          month: 12,
          day: 8,
        },
      },
      {
        color: 'green',
        date: {
          year: 2018,
          month: 12,
          day: 15,
        },
      },
      {
        color: 'green',
        date: {
          year: 2020,
          month: 3,
          day: 18,
        },
      },
      {
        color: 'red',
        date: {
          year: 2021,
          month: 2,
          day: 21,
        },
      },
      {
        color: 'green',
        date: {
          year: 2011,
          month: 10,
          day: 20,
        },
      },
    ],
    IndicePoints: [
      // {
      //   color: 'red',
      //   date: {
      //     year: 2010,
      //     month: 11,
      //     day: 8,
      //   },
      // },
      {
        color: 'red',
        date: {
          year: 2011,
          month: 6,
          day: 9,
        },
      },
      {
        color: 'red',
        date: {
          year: 2013,
          month: 4,
          day: 9,
        },
      },
      {
        color: 'red',
        date: {
          year: 2013,
          month: 11,
          day: 30,
        },
      },
      {
        color: 'green',
        date: {
          year: 2015,
          month: 1,
          day: 15,
        },
      },
      {
        color: 'red',
        date: {
          year: 2017,
          month: 12,
          day: 8,
        },
      },
      {
        color: 'green',
        date: {
          year: 2018,
          month: 12,
          day: 15,
        },
      },
      {
        color: 'green',
        date: {
          year: 2020,
          month: 3,
          day: 18,
        },
      },
      {
        color: 'red',
        date: {
          year: 2021,
          month: 2,
          day: 21,
        },
      },
      {
        color: 'green',
        date: {
          year: 2011,
          month: 10,
          day: 20,
        },
      },
    ],
  },
};
